export default __webpack_public_path__ + "static/media/Luggage.b73cf9a8.png";